<template>
  <v-row align="center" class="fill-height" justify="center">
    <v-col cols="12" lg="6" md="8" sm="10" xl="4">
      <ResetPasswordForm></ResetPasswordForm>
    </v-col>
  </v-row>
</template>

<script>
import ResetPasswordForm from '@/components/ResetPasswordForm'
export default {
  name: 'ResetPassword',
  components: { ResetPasswordForm },
}
</script>

<style scoped></style>
